export const MEDIEVAL_CONTENT = `1. 중세 음악이란?
서양 음악의 역사는 중세에서 시작됩니다.
대략 500년부터 1450년까지 약 1000년에 걸친 이 시기에, 오늘날 우리가 당연하게 여기는 악보, 음계, 화음의 기초가 모두 만들어졌습니다.
중세 음악은 크게 교회 음악과 세속 음악으로 나뉘며, 초기에는 교회가 음악의 거의 모든 것을 지배했습니다.
---
2. 뿌리 — 초기 교회 음악 (1~6세기)
기독교가 처음 퍼지던 시절, 신자들은 유대교 예배 방식을 그대로 이어받아 노래로 기도했습니다.
다윗의 시편을 암송하는 것이 핵심이었고, 악기는 거의 쓰지 않았습니다.
여기에 그리스, 로마, 비잔티움, 시리아, 이집트의 음악 문화가 하나씩 섞이면서 독자적인 교회 음악이 탄생했습니다.
노래 방식은 세 가지였습니다.
성직자 한 명이 혼자 부르는 독창, 독창자가 부르면 신자들이 따라 부르는 응창, 그리고 두 그룹이 번갈아 가며 노래하는 교창이 있었습니다.
이 중 교창은 이후 중세 내내 가장 중요한 예배 음악 형식으로 자리 잡습니다.
313년, 밀라노 칙령으로 기독교가 로마 제국의 공식 종교로 인정받으면서 교회 음악은 급격히 제도화됩니다.
이때부터 동방의 비잔티움 교회와 서방의 로마 가톨릭 교회가 서로 다른 방향으로 음악을 발전시키기 시작합니다.
4세기 밀라노의 주교 암브로시우스는 서방 교회음악의 기틀을 닦은 인물입니다.
그는 시리아와 히브리 전통에서 교창 창법을 가져오고, 직접 찬가를 작곡해 신도들이 함께 부를 수 있는 음악을 만들었습니다.
그의 작품 일부는 오늘날 가톨릭과 개신교 찬송가에 여전히 남아 있습니다.
---
3. 정리와 통일 — 그레고리오 성가 (6~9세기)
유럽 각지에서 제각각 다르게 불리던 교회 노래들을 하나로 모아 정리한 것이 그레고리오 성가입니다.
교황 그레고리오 1세의 이름을 땄지만, 실제로는 9세기에서 10세기에 걸쳐 로마와 프랑스 갈리아 지역의 성가를 통합, 편찬한 결과물입니다.
그레고리오 성가의 가장 큰 특징은 악기 반주 없이 목소리 하나로만 부르는 무반주 단선율이라는 점입니다.
멜로디는 8개의 교회선법이라는 독자적인 음계 체계를 따릅니다.
이 교회선법은 고대 그리스 음악 이론에서 이름을 빌려왔지만 내용은 전혀 다르며, 도리아·프리지아·리디아·믹솔리디아의 4가지 정격선법과 이에 대응하는 4가지 변격선법, 총 8가지로 구성됩니다.
악보는 네우마라는 독특한 기호 체계로 기록되었습니다.
네우마는 음의 상대적인 높낮이와 리듬, 뉘앙스를 손으로 그린 기호로 나타낸 것으로, 오늘날 악보의 먼 조상입니다.
11세기 이탈리아의 음악 이론가 구이도 다렛초는 4선보를 고안하고 도·레·미·파·솔·라에 해당하는 계이름 체계를 만들어 악보를 보고 노래하기 훨씬 쉽게 만들었습니다.
오늘날 우리가 쓰는 도레미파솔라시도의 직접적인 기원입니다.
그레고리오 교황은 전문 성가 학교를 세우고 훈련된 가수를 유럽 각지 교회에 파견해 성가를 보급했습니다.
덕분에 그레고리오 성가는 중세 내내 로마 가톨릭의 공식 예배 음악으로 자리 잡았으며, 1960년대 제2차 바티칸 공의회 이후 각국 언어 성가에 점차 자리를 내주기 전까지 1000년 이상 사용되었습니다.
---
4. 음악의 진화 — 오르가눔과 다성음악의 탄생 (9~12세기)
9세기 말, 서양 음악 역사상 가장 중요한 변화가 일어납니다.
단 하나의 선율만 존재하던 음악에 두 번째 목소리가 더해지기 시작한 것입니다.
이것이 바로 오르가눔으로, 다성음악의 출발점입니다.
초기 오르가눔은 단순했습니다.
그레고리오 성가의 멜로디를 테너가 부르면, 다른 성부가 그 위나 아래에서 4도 또는 5도 간격으로 평행하게 따라 부르는 방식이었습니다.
이후 성부들이 점차 독립적으로 움직이기 시작하면서 음악은 훨씬 복잡하고 풍부해집니다.
이 시기를 로마네스크 음악 시대라고도 합니다.
유럽의 로마네스크 건축 양식, 즉 두꺼운 돌벽과 반원형 아치로 대표되는 장중하고 엄숙한 분위기가 음악에도 그대로 반영된 시기입니다.
그레고리오 성가의 묵직하고 명상적인 성격이 이 건축적 분위기와 잘 어울립니다.
한편 교회 음악과 별개로 세속 음악도 싹트기 시작합니다.
남프랑스에서는 트루바두르, 북프랑스에서는 트루베르, 독일에서는 미네젱거라 불리는 음유시인들이 귀족 계층 사이에서 사랑, 기사도, 종교를 주제로 단선율 노래를 지어 불렀습니다.
이들의 음악은 대부분 악보로 남아 있는 세속 음악 중 가장 오래된 것들입니다.
---
5. 화음 음악의 완성 — 노트르담 악파와 고딕 음악 (12~13세기)
12세기 후반에서 13세기에 걸쳐, 파리 노트르담 대성당을 중심으로 유럽 최초의 본격적인 다성음악 악파가 탄생합니다.
바로 노트르담 악파입니다.
당시 하늘을 찌를 듯 솟아오른 고딕 대성당의 건축 정신이 음악에도 그대로 반영되어, 여러 성부가 복잡하게 얽히는 웅장한 다성음악이 만들어졌습니다.
합창장 레오니누스는 교회력 1년 치 전례용 다성음악 곡집을 편집했고, 그의 후계자 페로티누스는 이를 발전시켜 3성부와 4성부 음악을 만들었습니다.
여러 목소리가 동시에 서로 다른 리듬으로 노래하는 이 음악은 당시 사람들에게 충격적일 만큼 새로운 소리였습니다.
이 시기에 모테토라는 장르도 탄생합니다.
테너가 그레고리오 성가 멜로디를 부르는 동안 위쪽 성부들이 각기 다른 가사와 리듬으로 동시에 노래하는 형식입니다.
심지어 종교적인 가사와 세속적인 가사가 동시에 불리기도 했습니다.
모테토는 이후 르네상스와 바로크 시대까지 이어지는 중요한 음악 형식으로 자리 잡습니다.
13세기에는 음의 길이를 정확히 표기하는 정량기보법도 등장합니다.
수도사 프랑코가 1260년경에 쓴 논문 <정량음악론>이 그 이론적 기반을 닦았습니다.
이제 악보를 보는 것만으로 리듬까지 정확히 알 수 있게 된 것입니다.
---
6. 새로운 예술 — 아르스 노바 (14세기)
14세기에 들어서면서 음악은 또 한 번 크게 변합니다.
이론가 필립 드 비트리가 1323년경에 쓴 논문 <아르스 노바>, 즉 '새로운 예술'이라는 이름이 이 시대 음악 전체를 가리키는 말이 되었습니다.
반대로 13세기 음악은 '낡은 예술'이라는 뜻의 아르스 안티쿠아로 불리게 됩니다.
아르스 노바의 가장 큰 변화는 리듬입니다.
기존 음악은 기독교의 삼위일체를 상징하는 3박자가 원칙이었지만, 이 시기부터 2박자도 동등하게 사용되기 시작합니다.
개별 음의 길이를 더 세밀하게 나타내는 음표 체계가 발달하면서 훨씬 다양한 리듬 표현이 가능해졌습니다.
프랑스에서는 기욤 드 마쇼가 대표적인 작곡가입니다.
그는 다성 모테토를 다수 작곡했고, 기존에 그레고리오 성가만 사용하던 미사 전체를 다성음악으로 작곡한 최초의 인물이기도 합니다.
이탈리아에서도 마드리갈, 발라타, 카치아 같은 세속 다성 장르들이 꽃을 피웠습니다.
세속 음악이 교회 음악과 어깨를 나란히 하기 시작한 것입니다.
---
7. 중세의 마지막 — 부르고뉴 악파와 플랑드르 악파 (15세기)
15세기 전반, 프랑스 동북부 부르고뉴 공국을 중심으로 새로운 악파가 등장합니다.
뒤파이와 뱅슈와가 대표하는 부르고뉴 악파는 유럽 대륙의 다성음악 전통과 영국의 음악 수법을 종합해 세련되고 우아한 폴리포니 양식을 확립했습니다.
이들의 음악은 중세의 끝이자 르네상스의 시작을 알리는 것이었습니다.
영국에서는 13세기부터 이미 독특한 음악 문화가 발달해 있었습니다.
유럽 대륙이 4도·5도 음정만을 어울리는 소리로 여기던 시절에, 영국인들은 3도를 협화음으로 즐겨 사용했습니다.
오늘날 우리가 듣기에 가장 자연스럽고 아름다운 화음인 3도 화음이 영국에서 먼저 발달한 것입니다.
현존하는 가장 오래된 돌림노래인 「여름은 오도다」도 13세기 영국에서 만들어진 6성부 합창곡입니다.
15세기 후반, 부르고뉴 악파의 영향을 받아 현재의 벨기에와 북부 프랑스 지역인 플랑드르를 중심으로 더욱 발전된 악파가 등장합니다.
플랑드르 악파는 4성부 폴리포니를 표준으로 삼고, 각 성부가 동등하게 서로를 모방하며 진행하는 통모방 양식을 완성했습니다.
죠스캥 데 프레가 이 양식의 정점을 이룬 인물로, 그의 음악은 이후 르네상스 음악 전체의 모범이 됩니다.
성부는 점차 5성, 8성으로 확대되었고, 17세기에 이르러 성악 폴리포니는 기악과 오페라에 주도권을 넘기며 서서히 막을 내립니다.
---
8. 악기와 악보 출판
중세에는 다양한 악기가 사용되었습니다.
하프·류트·기타 같은 현악기, 트럼펫·플루트·백파이프 같은 관악기, 탬버린 같은 타악기, 그리고 포르타티브 오르간이라 불리는 소형 휴대용 오르간도 있었습니다.
오르간은 원래 비잔티움에서 기원한 악기로, 기원전 이집트에서 물의 힘으로 소리를 내는 수압 오르간이 발명된 것이 그 출발점입니다.
15세기 말에는 악보 인쇄 기술이 발달해 음악 문화가 폭발적으로 확산됩니다.
1501년 이탈리아 베네치아에서 페트루치가 인쇄한 「오데카톤」은 현존하는 가장 오래된 인쇄 악보로, 96곡의 다성음악이 수록되어 있습니다.
이후 악보 출판은 파리, 뉘른베르크 등 유럽 전역으로 퍼져 음악을 교회와 궁정이라는 특수한 공간에서 일반 가정까지 끌어내렸습니다.
---
전체 흐름 요약
유대교 예배 음악에서 출발한 초기 교회 음악은 암브로시우스 성가를 거쳐 그레고리오 성가로 통일·정리됩니다.
단 하나의 선율이었던 음악은 9세기 오르가눔을 시작으로 점차 여러 성부를 갖는 다성음악으로 발전합니다.
12~13세기 노트르담 악파가 다성음악의 이론과 형식을 정립하고, 14세기 아르스 노바가 리듬과 세속 음악을 폭발적으로 발전시킵니다.
15세기 부르고뉴·플랑드르 악파가 폴리포니를 완성하며 중세 음악은 막을 내리고, 그 유산 위에 르네상스 음악이 시작됩니다.`;

export const RENAISSANCE_CONTENT = `1. 르네상스 음악이란?
르네상스 음악은 대략 1420년부터 1600년 사이, 약 180년에 걸친 시기의 서양 음악을 말합니다.
르네상스라는 말은 원래 '고대 문화의 부흥'을 뜻하지만, 음악에서는 고대 그리스 음악을 직접 부활시킨 것이 아니라 인간의 감정과 개성을 자유롭게 표현하고 합리성과 조화를 추구하는 새로운 정신이 음악에 반영된 시대로 이해하는 것이 정확합니다.
중세 음악이 교회와 신 중심이었다면, 르네상스 음악은 점차 인간 중심으로 옮겨가는 흐름을 보입니다.
복잡한 대위법 기교를 유지하면서도 그것이 단순한 기술 과시가 아니라 보다 자연스럽고 인간적인 감정 표현과 연결되기 시작했다는 점이 가장 큰 특징입니다.
또한 악보 인쇄술의 발명, 세속 음악의 급성장, 기악의 독립이라는 세 가지 변화가 이 시기를 주도했습니다.
---
2. 전체 흐름 한눈에 보기
15세기 전반에는 프랑스 북동부의 부르고뉴 지역을 중심으로 중세 폴리포니가 완성되며 르네상스 음악의 문이 열렸습니다.
15세기 후반부터 16세기 전반까지는 플랑드르 악파가 통모방 폴리포니를 완성하였고, 조스캥 데 프레가 이 시기를 대표하는 작곡가로 활약했습니다.
16세기 전반부터 후반까지는 음악의 중심이 이탈리아로 이동했습니다.
베네치아와 로마를 중심으로 마드리갈이 발전하고 교회음악이 절정에 이르렀으며 기악 음악도 크게 성장했습니다.
16세기 중반 독일에서는 마르틴 루터의 종교개혁으로 프로테스탄트 코랄이 탄생하며 새로운 교회음악 전통이 형성되었습니다.
16세기 후반 영국에서는 버지널 음악과 영국 마드리갈이 발전하며 독자적인 음악 문화를 꽃피웠습니다.
16세기 말에서 17세기 초에 이르러 이탈리아 피렌체에서 오페라가 탄생하였고, 이는 르네상스 음악이 바로크 음악으로 넘어가는 중요한 전환점이 되었습니다.
---
3. 출발점 — 플랑드르 악파와 조스캥 데 프레 (15세기~16세기 초)
중세 말 부르고뉴 악파에서 시작된 폴리포니 전통은 15세기 후반 플랑드르 악파에 이르러 완성 단계에 접어듭니다.
플랑드르 악파의 작곡가들은 전 유럽 궁정과 교회에서 활동하며 르네상스 음악의 기준을 세웠습니다.
이 시기의 핵심 기법은 통모방 양식입니다.
이는 각 성부가 똑같이 하나의 선율을 순서대로 모방하며 진행하는 방식으로, 특정 성부 하나가 주도하고 나머지가 따라가던 중세 방식과 달리 모든 성부가 평등하게 참여합니다.
마치 여러 사람이 같은 말을 조금씩 시차를 두고 반복하는 것과 같습니다.
이 양식을 완성한 인물이 조스캥 데 프레입니다.
그는 플랑드르 출신으로 이탈리아를 비롯한 유럽 각지에서 활동했으며, 당시 사람들에게 '음악의 왕자'로 불렸습니다.
그의 음악은 복잡한 대위법 기교를 갖추면서도 선율이 자연스럽고 가사의 내용을 음악으로 표현하는 힘이 뛰어났습니다.
조스캥 이후 르네상스 음악의 중심은 플랑드르에서 이탈리아로 넘어가기 시작합니다.
---
4. 이탈리아 — 마드리갈과 두 개의 악파 (16세기)
16세기에 들어서면서 음악의 중심이 이탈리아로 이동하고, 이탈리아 반도에서 르네상스 정신은 가장 풍성하게 꽃을 피웁니다.
이탈리아 음악은 크게 베네치아 악파와 로마 악파로 나뉘며, 두 악파는 서로 다른 방향으로 음악을 발전시켰습니다.
마드리갈은 이탈리아에서 탄생한 다성 세속 가곡 형식으로, 페트라르카 같은 시인의 서정시에 음악을 붙인 것입니다.
처음에는 3~4성부로 시작해 차차 5성부가 중심이 되었고, 가사의 내용을 음악으로 표현하는 기법이 점점 정교해졌습니다.
예를 들어 가사에 '하늘로 올라간다'는 표현이 나오면 선율도 위로 올라가고, '죽음'이라는 단어에는 어두운 화음을 배치하는 식입니다.
이를 음화라 하며, 르네상스 마드리갈의 가장 큰 특징입니다.
마드리갈을 완성한 인물은 루카 마렌치오이며, 그는 이후 영국과 독일 음악에도 큰 영향을 미쳤습니다.
---
5. 음계의 변화 — 교회선법에서 장조·단조로
중세 내내 음악을 지배하던 8개의 교회선법은 르네상스 시대에 들어서면서 조금씩 흔들리기 시작합니다.
세속 음악이 번성하면서 사람들이 자연스럽게 오늘날의 장음계와 단음계에 가까운 음계를 선호하게 되었기 때문입니다.
스위스의 음악 이론가 글라레아누스는 1547년에 저서 「12음계론」을 통해 기존 8개 선법에 이오니아 선법과 에올리아 선법을 추가해 12개 선법 체계를 완성합니다.
이 중 이오니아 선법이 오늘날의 장조, 에올리아 선법이 단조로 발전합니다.
즉 르네상스 시대가 끝날 무렵, 수백 년간 이어온 교회선법 체계는 장조와 단조 두 가지로 수렴되기 시작하고, 이 흐름은 바로크 시대에 완전히 굳어집니다.
---
6. 종교개혁과 프로테스탄트 코랄 — 독일 (16세기)
1517년 마르틴 루터가 종교개혁을 시작하면서 음악에도 큰 변화가 찾아옵니다.
루터는 라틴어로만 진행되던 가톨릭 예배 음악 대신, 신자들이 직접 독일어로 부를 수 있는 단순하고 힘찬 찬송가를 만들고자 했습니다.
이렇게 탄생한 것이 프로테스탄트 코랄입니다.
코랄의 가사와 멜로디는 세 종류로 구성됩니다.
루터 자신이 직접 작사·작곡한 곡, 기존 가톨릭 성가를 편곡한 곡, 그리고 민요의 선율과 가사를 종교적 내용으로 바꾼 곡입니다.
처음에는 단선율로 모두가 함께 부르는 형식이었으나, 점차 플랑드르 악파의 다성 모테토 기법을 도입해 4성부 합창으로 발전합니다.
요한 발터와 하슬러가 이 발전에 기여한 주요 작곡가들입니다.
프로테스탄트 코랄은 이후 독일 음악의 기둥이 됩니다.
미하엘 프레토리우스에서 시작해 결국 요한 세바스티안 바흐의 코랄 편곡에 이르기까지, 독일 프로테스탄트 음악의 영광은 이 시기에 탄생한 코랄 전통 위에 세워진 것입니다.
---
7. 영국 — 버지널과 마드리갈의 황금기 (16세기)
16세기 영국은 엘리자베스 1세 시대의 문화적 황금기였습니다.
셰익스피어가 불멸의 희곡을 쓰던 이 시기에 영국 음악도 독자적인 꽃을 피웠습니다.
교회음악 분야에서는 탈리스가 대위법의 기교로 두각을 나타냈고, 엘리자베스 왕조 최대의 작곡가 윌리엄 버드는 교회음악, 세속 합창곡, 실내악, 건반악기 음악 등 당시 모든 장르에서 탁월한 작품을 남겼습니다.
그러나 영국 르네상스 음악에서 가장 독창적인 성과는 버지널 음악입니다.
버지널은 건반을 눌러 현을 뜯는 작은 건반악기로, 하프시코드의 일종입니다.
16세기 말 영국에서 버드를 중심으로 한 버지널리스트들이 이 악기를 위한 춤곡, 변주곡, 판타지아, 전주곡 등을 대거 작곡했습니다.
이들의 작품은 「파르테니아」와 「피츠윌리엄 버지널의 책」에 수록되어 있으며, 건반악기 독주 음악의 가장 이른 걸작 모음집으로 평가받습니다.
---
8. 기악의 독립과 악기의 발전
르네상스 시대는 기악이 성악의 반주 역할에서 벗어나 독립적인 예술로 발전하기 시작한 시기입니다.
오르간과 류트가 궁정 음악의 중심이 되었고, 리체르카레, 판타지아, 칸초네 같은 순수 기악 장르들이 탄생했습니다.
리체르카레는 '탐구한다'는 뜻의 이탈리아어에서 유래한 장르로, 성악 모테토의 작법을 기악에 적용한 것입니다.
여러 주제를 모방적으로 발전시키는 이 형식은 훗날 바로크 시대의 푸가로 직결됩니다.
프랑스 샹송을 기악용으로 편곡한 칸초네 역시 17세기 소나타의 직접적인 조상입니다.
악기 제작에서도 중요한 변화가 있었습니다.
이탈리아 베네치아에 극장이 건립되고 오페라와 기악 합주가 시민에게 개방되면서, 넓은 공간을 채울 수 있는 더 크고 강한 소리의 악기가 필요해졌습니다.
이런 수요에 맞춰 기존의 비올족 악기를 대체할 바이올린족이 등장합니다.
바이올린의 기원은 16세기 30~40년대까지 거슬러 올라가며, 크레모나의 아마티 가문, 과르네리, 스트라디바리 등의 명장들이 이 악기를 완성해 나갔습니다.
---
9. 마무리 — 오페라의 탄생과 바로크로의 전환
16세기 말, 이탈리아 피렌체에서 카메라타라 불리는 지식인·예술가 모임이 고대 그리스 연극을 음악으로 부활시키려는 시도를 합니다.
이들은 복잡한 다성음악 대신 가사가 잘 들리는 단선율 선창 방식, 즉 모노디를 주장했고, 이것이 오페라의 직접적인 출발점이 됩니다.
1600년에 초연된 「에우리디체」는 현존하는 가장 오래된 오페라입니다.
동시에 마드리갈은 가사의 극적 표현을 점점 더 강하게 추구하면서 반음계법과 불협화음을 대담하게 사용하기 시작합니다.
이 흐름은 클라우디오 몬테베르디로 이어지며, 그는 르네상스 마드리갈과 바로크 오페라를 동시에 대표하는 인물이 됩니다.
르네상스 음악은 중세가 쌓아올린 폴리포니 전통 위에서 인간적인 감정 표현과 기악의 독립이라는 두 가지 방향으로 발전하며, 그 끝에서 오페라와 소나타, 푸가라는 바로크 음악의 핵심 장르들을 낳고 막을 내립니다.
---
전체 흐름 요약
플랑드르 악파가 통모방 폴리포니를 완성하면서 르네상스 음악은 시작됩니다.
16세기 이탈리아에서는 베네치아 악파가 공간 음향과 기악을 발전시키고, 로마 악파 팔레스트리나가 교회음악을 정점에 올려놓습니다.
마드리갈이라는 세속 장르는 감정 표현의 새 지평을 열고, 독일에서는 루터의 종교개혁이 프로테스탄트 코랄을 탄생시킵니다.
영국은 버지널 음악으로 건반악기 독주 문화를 꽃피웁니다.
16세기 말, 기악의 독립과 오페라의 탄생이 맞물리며 르네상스 음악은 바로크 음악으로 넘어갑니다.`;

export const BAROQUE_CONTENT = `1. 바로크 음악이란?
바로크 음악은 1600년부터 1750년까지 약 150년에 걸친 서양 음악을 말합니다.
바로크라는 단어는 포르투갈어 '바호코'에서 유래했으며, 원래 '찌그러진 진주' 또는 '괴이한 형태의 진주'라는 뜻입니다.
처음에는 이 시대의 음악을 비판하는 맥락에서 쓰였습니다.
철학자 장자크 루소는 1768년에 바로크 음악을 "화성이 혼란스럽고 불협화음으로 가득하며 노래는 거슬리고 음정도 잡기 어려운 음악"이라고 혹평했을 정도입니다.
그러나 현대에는 오히려 이 시대 음악의 풍부한 표현력과 복잡한 구조가 높이 평가받고 있습니다.
바로크 음악의 시대적 배경을 보면, 정치적으로는 루이 14세로 대표되는 절대 왕정 시대였고 경제적으로는 중상주의, 사상적으로는 합리주의와 계몽주의가 싹트던 시기였습니다.
음악의 무대는 교회 중심에서 왕실 궁정과 공개 극장으로 점차 확대되었고, 이 변화가 새로운 장르와 형식들을 만들어냈습니다.
바로크 음악의 가장 핵심적인 미학은 정서론입니다.
음악의 궁극적인 목적이 듣는 사람의 감정을 움직이는 데 있다는 생각으로, 중세와 르네상스 음악이 신을 향한 봉사나 기교적 완성에 초점을 맞췄다면 바로크 음악은 인간의 감정을 직접적으로 표현하고 자극하는 것을 목표로 삼았습니다.
---
2. 시대 구분
초기 바로크는 1580년부터 1630년까지의 시기입니다.
이 시기에는 오페라가 탄생하고 모노디가 등장했으며 통주저음이 확산되었습니다.
중기 바로크는 1630년부터 1680년까지의 시기입니다.
칸타타와 오라토리오 형식이 확립되었으며 절대왕정 시대의 궁정음악이 발전했습니다.
후기 바로크는 1680년부터 1750년까지의 시기입니다.
협주곡과 푸가가 완성되었고 바흐와 헨델에 의해 바로크 음악이 절정에 이르렀습니다.
이탈리아는 다른 유럽 지역보다 약 20년 정도 앞서 발전했습니다.
이탈리아에서는 1730년대에 이미 다음 시대인 고전주의로 넘어가는 갈랑 양식이 등장했지만 독일에서는 1750년까지 바로크 음악의 전성기가 이어졌습니다.
---
3. 핵심 개념 — 통주저음과 조성 체계
바로크 음악을 '통주저음의 시대'라 부를 만큼 통주저음은 이 시대를 대표하는 기법입니다.
악보의 베이스 음표 아래에 숫자로 화음을 표기하면 하프시코드나 오르간, 류트 연주자가 그 숫자를 보고 즉흥적으로 화음을 채워 연주하는 방식입니다.
오늘날 재즈에서 코드 기호를 보고 피아니스트가 즉흥 반주를 하는 것과 비슷한 개념입니다.
현존하는 통주저음의 가장 오래된 예는 1600년에 출판된 페리의 오페라 「에우리디체」입니다.
이와 함께 르네상스 시대까지 이어온 교회선법 체계가 완전히 사라지고 오늘날 우리에게 익숙한 장조와 단조의 조성 체계가 확립됩니다.
작곡가들은 화성 진행, 즉 화음들이 서로 어떻게 연결되는지에 집중하기 시작했고 조성을 더 명확히 표현하기 위한 종지 기법들이 발전했습니다.
이로써 중세 이래 천 년 가까이 음악을 지배하던 선법 체계가 역사 속으로 사라지고 근대 음악 이론의 기반이 완성됩니다.
---
4. 초기 바로크 — 오페라의 탄생 (1580~1630년)
르네상스 말기 피렌체에서 귀족 지오반니 드 바르디의 후원 아래 카메라타라는 지식인 모임이 만들어졌습니다.
이들은 고대 그리스의 연극을 이상적인 예술 형태로 보고 가사가 잘 들리지 않는 복잡한 다성음악 대신 단 하나의 선율에 단순한 반주가 따르는 모노디를 주창했습니다.
모노디의 원칙은 명확합니다.
언어가 음악을 지배하고 가사의 리듬과 억양이 멜로디에 그대로 반영되며 복잡한 대위법 대신 단순한 반주가 독창자를 뒷받침해야 한다는 것입니다.
이 원칙을 바탕으로 1600년 피렌체에서 자코모 페리와 줄리오 카치니가 「에우리디체」를 각각 작곡해 상연했습니다.
이것이 현존하는 가장 오래된 오페라입니다.
클라우디오 몬테베르디는 르네상스와 바로크를 동시에 대표하는 인물로 바로크 음악을 사실상 열었다는 평가를 받습니다.
1607년 만토바에서 초연된 그의 오페라 「오르페오」는 카메라타의 모노디 원칙을 계승하면서도 풍부한 오케스트라 음향과 생생한 극적 표현, 체계적인 형식을 갖추어 초기 오페라 중 가장 뛰어난 작품으로 손꼽힙니다.
그는 또한 현악기의 트레몰로 주법을 처음 사용하여 분노와 흥분의 감정을 음악으로 표현하는 새로운 길을 열었습니다.
---
5. 중기 바로크 — 새로운 성악 장르와 궁정음악 (1630~1680년)
1637년 베네치아에 세계 최초의 공개 오페라 극장 산캇시아노가 문을 열면서 오페라는 귀족만의 행사에서 시민이 돈을 내고 즐기는 공연 예술로 변모합니다.
베네치아 오페라는 신화와 역사를 소재로 하면서 레치타티보와 아리아가 형식적으로 분리되기 시작하고 화려한 무대 장치와 A-B-A 구조의 다 카포 아리아 형식이 자리 잡기 시작합니다.
칸타타는 레치타티보와 아리아를 번갈아 배치하고 악기 반주가 따르는 성악 형식입니다.
초기에는 세속적인 내용을 다루었으나 점차 종교적 소재로도 확장되었고 바흐에 이르러 교회 칸타타 형식으로 완성됩니다.
오라토리오는 성경이나 종교적 이야기를 독창, 합창, 관현악으로 표현하는 형식입니다.
오페라와 구조는 비슷하지만 무대 장치와 의상, 연기 없이 음악만으로 연주합니다.
루이 14세 치하의 프랑스에서는 부와 권력이 궁정으로 집중되면서 음악의 중심도 교회에서 왕실로 옮겨갑니다.
이탈리아 출신으로 프랑스 궁정에 고용된 장바티스트 륄리는 프랑스 오페라의 기초를 확립하고 현악 중심의 오케스트라 편성을 만들었습니다.
그는 역사에 기록된 최초의 지휘자 중 한 명으로 긴 지팡이로 박자를 치며 연주자들을 이끌었다고 전해집니다.
그런데 이 지팡이로 박자를 치다가 자기 발을 찍어 그 상처로 사망했다는 일화가 남아 있습니다.
륄리가 만든 느림-빠름-느림 구조의 프랑스풍 서곡은 바로크 시대 전반에 걸쳐 널리 애호되었습니다.
---
6. 후기 바로크 — 기악의 완성과 두 거장 (1680~1750년)
바로크 이전까지 기악은 성악의 반주에 불과했습니다.
바로크 시대에 이르러 기악이 처음으로 성악과 대등한 위치를 차지하고 독자적인 형식들이 완성됩니다.
푸가는 하나의 짧은 주제를 각 성부가 차례로 모방하며 복잡하게 발전시키는 대위법적 기악 형식입니다.
리체르카레와 칸초나에서 출발해 북독일의 북스테후데와 파헬벨을 거쳐 바흐에서 절정에 이릅니다.
협주곡은 바로크 시대의 가장 중요한 관현악 형식입니다.
합주 협주곡은 소수의 독주 악기군과 전체 합주단이 번갈아 연주하며 대화하는 형식으로 헨델의 「콘체르토 그로소」와 바흐의 「브란덴부르크 협주곡」이 대표적입니다.
독주 협주곡은 하나의 독주 악기가 오케스트라와 겨루는 형식으로 토렐리와 알비노니가 선구자였고 비발디가 빠름-느림-빠름의 3악장 형식으로 완성했습니다.
비발디는 생애 동안 약 500곡의 협주곡을 작곡했으며 그의 형식을 바흐와 헨델 모두 이어받았습니다.
---
7. 바로크의 두 거장 — 바흐와 헨델
바로크 음악은 요한 제바스티안 바흐와 게오르크 프리드리히 헨델이라는 두 거장의 등장으로 절정에 이르고 마무리됩니다.
공교롭게도 두 사람은 모두 1685년에 독일에서 태어났지만 단 한 번도 만나지 못했습니다.
바흐는 유서 깊은 음악가 집안 출신으로 평생 독일을 떠나지 않으며 교회와 궁정에서 봉직했습니다.
두 번의 결혼으로 20명의 자녀를 두었으며 경건하고 내면적인 성격이었습니다.
그의 작품은 오페라를 제외한 거의 모든 바로크 장르를 망라했는데 핵심은 교회 칸타타와 오르간 음악이었습니다.
바흐의 칸타타는 약 200곡이 현존하며 푸가 기법은 「평균율 클라비어곡집」과 「푸가의 기법」에서 극한까지 발전시켰습니다.
그의 음악은 단순히 아름다운 멜로디가 아니라 수학적 완결성과 신학적 의미가 결합된 것으로 「마태 수난곡」과 「b단조 미사」는 서양 음악사에서 가장 심오한 작품으로 꼽힙니다.
헨델은 바흐와 정반대의 삶을 살았습니다.
독일을 떠나 이탈리아와 영국을 무대로 활동하며 결혼도 하지 않고 국제적인 음악 사업가로 살았습니다.
외향적이고 화려하며 귀족적인 성격이었고 영국에 귀화해 영국 국민 음악가가 되었습니다.
특히 오라토리오에서 두각을 나타냈는데 「메시아」는 그 절정으로 초연 이후 지금까지도 전 세계에서 연주되고 있습니다.
두 사람의 차이를 한 문장으로 정리하면 바흐는 독일 프로테스탄트 음악 전통의 최후 완성자였고 헨델은 이탈리아·프랑스·독일·영국의 양식을 모두 흡수한 국제주의의 상징이었습니다.
---
8. 악기의 발전
하프시코드는 바로크 시대의 대표적 건반악기였습니다.
건반을 눌러 현을 뜯어 소리를 냈으며 통주저음 연주의 핵심 악기이자 독주 악기로도 폭넓게 사용되었습니다.
한편 이탈리아의 악기 제작자 바르톨로메오 크리스토포리가 18세기 초에 건반을 누르는 힘에 따라 소리의 세기가 달라지는 새로운 건반악기를 발명했습니다.
이것이 피아노포르테이며 오늘날 피아노의 직접적인 조상입니다.
바이올린은 르네상스 말기에 등장해 바로크 시대에 완성되었습니다.
크레모나의 아마티 가문이 기초를 닦고 스트라디바리와 과르네리가 현재까지도 최고의 악기로 인정받는 명기들을 제작했습니다.
---
전체 흐름 요약
르네상스 말 피렌체 카메라타의 모노디 실험에서 출발한 바로크 음악은 오페라를 탄생시키고 통주저음과 조성 체계를 확립했습니다.
몬테베르디가 문을 열고 중기에는 오페라, 칸타타, 오라토리오가 형식을 갖추면서 궁정음악이 꽃을 피웠습니다.
후기에는 협주곡, 푸가, 소나타, 모음곡의 기악 형식이 완성되었습니다.
비발디가 협주곡을 발전시켰고 바흐와 헨델이 각자의 방식으로 바로크 음악 전체를 집대성했습니다.
1750년 바흐의 사망과 함께 바로크 시대는 막을 내렸습니다.`;

export const CLASSICAL_CONTENT = `1. 고전주의 음악이란?
고전주의 음악은 1750년경부터 1810년경까지 주로 오스트리아 빈을 중심으로 발전한 서양 음악 사조입니다.
여기서 '고전'이라는 말에는 단순한 시대 구분이 아니라 '모범적 예술, 균형적 형식, 누구에게나 쉽게 이해되는 보편성'이라는 질적 의미가 담겨 있습니다.
처음에는 하이든·모차르트·베토벤의 음악을 다른 음악과 구별하는 질적 개념으로 쓰였고, 이들의 교향곡이 1800년대 초 연주회의 모범 레퍼토리로 자리 잡으면서 시대 개념으로 굳어졌습니다.
고전주의 음악은 세 가지 가치를 추구합니다.
첫째, 자연스러움으로 감정적으로 함께 느낄 수 있는 방식을 지향합니다.
둘째, 단순성으로 민요처럼 친근한 것을 예술 음악의 출발점으로 삼습니다.
셋째, 보편성으로 특정 계층이 아닌 세상 누구나 알아들을 수 있는 음악을 목표로 합니다.
이 세 가지는 바로크 음악의 복잡한 대위법과 통주저음 중심 음악에 대한 반발로 나온 것입니다.
---
2. 시대 배경 — 왜 바로크에서 고전주의로 바뀌었나?
1750년 바흐가 사망하고 같은 해 헨델이 사실상 활동을 마감하면서 바로크 시대는 막을 내립니다.
이 시기 유럽 사회는 큰 변화의 한가운데 있었습니다.
정치적으로는 루이 14세식 절대 왕정이 흔들리고 계몽주의 사상이 퍼지면서 인간의 이성과 자유를 중시하는 분위기가 확산되었습니다.
음악의 후원 구조도 달라졌습니다.
바로크 시대에는 교회와 극소수 왕실 귀족이 음악가를 고용하는 방식이었지만, 18세기 중반부터는 시민 계층이 성장하면서 공개 연주회가 늘어나고 음악의 청중이 넓어졌습니다.
음악은 이제 교회 예배나 왕실 오락만이 아니라 일반 시민도 즐기는 것이 되었습니다.
작곡 방식도 여러 성부가 복잡하게 얽히는 대위법 중심에서 명료한 하나의 선율에 단순한 화음 반주가 따르는 호모포니 중심으로 전환됩니다.
---
3. 세 가지 새로운 양식 경향
갈랑 양식은 18세기 화려한 귀족 살롱 문화를 반영한 음악 양식입니다.
바로크 음악의 두꺼운 대위법적 짜임새 대신 섬세하고 우아한 선율, 단순한 형식, 세속적이고 사교적인 성격을 특징으로 합니다.
감정 과다양식은 갑작스러운 강약 변화, 예상치 못한 화성 전환, 짧고 불규칙한 악절 등으로 듣는 사람의 감정을 직접 자극하는 방식입니다.
이 양식의 대표 인물은 대바흐의 둘째 아들 칼 필립 엠마누엘 바흐입니다.
하이든과 모차르트 모두 그의 음악에서 직접적인 영향을 받았다고 인정했습니다.
슈투름 운트 드랑, 즉 '질풍과 노도'의 정신이 음악에도 영향을 미쳤습니다.
음량의 강렬한 대비, 단조의 사용, 빠른 리듬 변화, 불안한 화성 진행 등이 특징입니다.
---
4. 핵심 형식의 확립 — 소나타 형식과 4악장 구조
소나타 형식은 고전주의 음악의 뼈대로 특히 교향곡이나 소나타의 첫 번째 악장에 사용되는 구조입니다.
제시부에서는 성격이 다른 두 개의 주제가 차례로 등장합니다.
제1주제는 보통 힘차고 확신에 찬 성격입니다.
제2주제는 보다 서정적이고 부드러운 성격으로 딸림조에서 나타납니다.
발전부에서는 두 주제가 다양한 방식으로 변형되고 발전됩니다.
재현부에서는 두 주제가 다시 등장하되 모두 으뜸조에서 나타나며 안정감 있게 마무리됩니다.
이 구조는 두 주제의 긴장과 해소, 조성의 이탈과 귀환이라는 극적인 흐름을 만들어 냅니다.
4악장 교향곡 구조는 이 소나타 형식을 제1악장으로 삼습니다.
제2악장은 느린 악장, 제3악장은 미뉴에트 형식의 춤곡 악장, 제4악장은 빠른 론도 형식으로 구성됩니다.
---
5. 요제프 하이든 — 교향곡과 현악 사중주의 아버지
하이든(1732~1809)은 오스트리아 로라우 출신으로 1761년부터 약 30년간 헝가리 에스테르하지 가문의 전속 악장으로 일했습니다.
교향곡 104곡, 현악 사중주 68곡, 피아노 소나타 62곡, 오페라 20곡 이상이라는 방대한 작품을 남겼습니다.
하이든의 초기 교향곡은 바로크와 초기 고전파의 영향이 뒤섞인 실험적 작품들이었습니다.
1780년대 후반부터 하이든은 귀족 가문의 전속이라는 틀을 넘어 파리와 런던의 출판사로부터 위촉을 받기 시작했습니다.
이 시기에 작곡한 「파리 교향곡」과 「런던 교향곡」은 그의 교향곡 작법이 절정에 이른 작품들입니다.
교향곡 제94번 「놀람」은 느린 2악장에서 갑자기 큰 소리가 터지는 효과로 유명합니다.
교향곡 제101번 「시계」는 2악장의 규칙적인 반주가 시계 소리를 연상시켜 붙은 이름입니다.
현악 사중주는 바이올린 2대, 비올라 1대, 첼로 1대로 구성된 실내악입니다.
하이든은 수십 년 동안 이 형식을 발전시켜 「러시아 사중주」와 「황제 사중주」에서 정점에 도달했습니다.
---
6. 볼프강 아마데우스 모차르트 — 형식을 예술로 바꾼 천재
모차르트(1756~1791)는 잘츠부르크에서 태어나 어린 시절부터 신동으로 유럽 각지를 여행하며 이탈리아, 프랑스, 독일, 영국의 음악을 모두 흡수했습니다.
1781년 잘츠부르크 대주교와 결별하고 빈으로 이주해 프리랜서 음악가로 활동했습니다.
1791년 35세의 나이에 「레퀴엠」을 미완성으로 남긴 채 세상을 떠났습니다.
모차르트의 가장 놀라운 특징은 거의 모든 음악 장르에서 최고 수준의 작품을 남겼다는 점입니다.
교향곡 41곡, 피아노 협주곡 27곡, 현악 사중주 23곡, 오페라 22곡, 피아노 소나타 18곡 등 600곡이 넘는 작품을 남겼습니다.
교향곡 제39번은 서정적이고 우아한 분위기를 지닙니다.
교향곡 제40번은 어둡고 긴장감 있는 단조 교향곡으로 유명합니다.
교향곡 제41번 「주피터」는 고전적 소나타 형식과 바로크 푸가 기법을 결합한 걸작입니다.
「피가로의 결혼」은 귀족과 하인의 갈등을 통해 신분 질서를 풍자한 작품입니다.
「돈 조반니」는 코미디와 비극을 결합한 혁신적인 오페라입니다.
「마술 피리」는 철학적 의미와 대중적 매력을 동시에 지닌 독일어 오페라입니다.
---
7. 하이든과 모차르트 — 상호 존경의 이야기
하이든과 모차르트의 관계는 음악사에서 가장 아름다운 상호 존경의 사례로 꼽힙니다.
모차르트는 하이든의 작품 33번 현악 사중주에 깊은 감명을 받았습니다.
그는 이에 대한 존경의 표시로 6곡의 현악 사중주를 작곡하여 하이든에게 헌정했습니다.
하이든은 모차르트의 아버지 레오폴트에게 "신 앞에서, 그리고 정직한 인간으로서 말하건대 당신의 아들은 내가 아는 가장 위대한 작곡가입니다."라고 말했다고 전해집니다.
하이든이 런던으로 떠날 때 모차르트는 눈물을 흘리며 "이것이 마지막 이별이 될 것 같습니다."라고 말했다고 합니다.
실제로 그것이 마지막 만남이 되었고 하이든은 런던에서 모차르트의 사망 소식을 듣게 됩니다.
---
8. 베토벤 — 고전주의의 끝이자 낭만주의의 시작
베토벤(1770~1827)은 하이든·모차르트와 함께 빈 고전파의 3대 거장으로 꼽히지만, 그의 음악은 고전주의의 틀 안에 머물지 않고 그 경계를 부수며 낭만주의로 가는 길을 직접 열었습니다.
베토벤은 1798년경부터 청력이 서서히 나빠지기 시작했습니다.
40대 중반 이후에는 완전히 청각을 잃었습니다.
귀가 들리지 않는 음악가가 인류 역사상 가장 위대한 음악들을 만들어냈다는 것은 그의 음악이 단순한 기교나 귀의 쾌락이 아니라 내면에서 울려 나오는 정신의 산물임을 보여줍니다.
교향곡 제3번 「영웅」, 제5번 「운명」, 제6번 「전원」, 제9번 「합창」이 대표작입니다.
교향곡 제9번에서는 실러의 「환희의 송가」를 독창자와 합창단이 노래하게 했습니다.
초연 당시 베토벤은 청중의 박수 소리를 듣지 못하고 있었습니다.
한 독창자가 그를 객석 쪽으로 돌려 세운 뒤에야 청중이 기립박수를 보내고 있다는 사실을 알게 되었다는 유명한 일화가 전해집니다.
피아노 소나타 「비창」, 「월광」, 「열정」은 각 시기의 정점을 나타냅니다.
베토벤은 고전주의가 완성한 형식을 버리지 않았습니다.
그러나 그 안에 전례 없는 규모와 강도, 개인적 주관성을 불어넣었고, 음악은 단순한 오락이 아니라 인간 정신의 표현 수단이 되었습니다.
1827년 베토벤이 세상을 떠나면서 고전주의 시대는 사실상 막을 내리게 됩니다.
그러나 그의 음악은 끝이 아니라 시작이었습니다.
베토벤은 고전주의의 마지막 거장이자 낭만주의의 첫 번째 거장이라고 불립니다.`;

export const ROMANTIC_CONTENT = `1. 낭만주의란 무엇인가?
낭만주의 음악은 일반적으로 1815년 나폴레옹 패전 이후부터 19세기 말까지를 가리킵니다.
고전주의가 '균형, 형식, 보편성'을 목표로 삼았다면, 낭만주의는 정반대 방향을 향합니다.
개인의 내면, 자연에 대한 동경, 민족적 정체성, 초자연과 환상의 세계가 음악의 중심 주제가 됩니다.
음악은 더 이상 형식적 완결을 추구하는 예술이 아니라 말로 표현할 수 없는 인간 감정의 가장 깊은 층을 끌어내는 언어가 됩니다.
E. T. A. 호프만이 "음악은 인간에게 알려지지 않은 영역을 개척해 준다"고 쓴 것이 이 시대의 음악관을 잘 요약합니다.
---
2. 시대 배경 — 혁명, 개인, 그리고 시민 사회
프랑스 혁명과 나폴레옹 전쟁이 유럽의 구질서를 뒤흔들고 산업혁명이 사회 구조를 바꾸는 거대한 변동 속에서 낭만주의가 태어났습니다.
귀족 중심의 후원 체계가 무너지면서 음악가는 더 이상 누군가의 하인이 아니라 독립적인 예술 창조자가 되었습니다.
귀족의 취향에 맞춰야 했던 고전주의 음악과 달리 낭만주의 작곡가들은 자신의 감정과 생각을 직접 음악으로 표현하기 시작했습니다.
예술가는 고독한 천재이자 사회의 아웃사이더라는 낭만주의적 예술가상이 이 시기에 탄생했습니다.
공개 연주회가 늘어나고 악보 출판이 활발해지면서 음악은 살롱과 가정으로 파고들었습니다.
피아노의 급격한 발전도 이러한 흐름을 뒷받침했습니다.
---
3. 고전주의에서 낭만주의로 — 무엇이 달라졌나?
고전주의에서 음악은 형식 안에서 감정을 절제하고 균형을 유지하는 것이 미덕이었습니다.
낭만주의에서는 내용이 구조를 지배합니다.
표현하고자 하는 감정과 이야기가 형식보다 우선합니다.
화성 언어도 변합니다.
고전주의의 화성이 안정과 해결을 향해 명확하게 움직였다면 낭만주의는 해결되지 않는 긴장과 예상치 못한 전조, 색채적이고 모호한 화음을 적극 사용합니다.
이러한 불안정한 화성은 낭만주의 특유의 동경과 갈망, 멜랑콜리의 감정을 만들어 냅니다.
---
4. 새로운 형식과 장르의 탄생
연가곡은 하나의 시 모음집에 곡을 붙여 이야기의 흐름을 따라가는 성악 형식입니다.
녹턴은 밤의 명상적 분위기를 담은 짧은 피아노곡입니다.
즉흥곡은 자유롭게 흐르는 즉흥적 느낌의 소품입니다.
무언가는 가사 없는 노래라는 뜻으로 피아노가 노래하듯 연주되는 서정적인 작품입니다.
이 장르들은 오케스트라 없이 가정의 피아노에서 연주할 수 있었기 때문에 빠르게 보급되었습니다.
연주회용 서곡도 등장했습니다.
오페라 서곡이 아니라 문학 작품이나 자연 풍경에서 영감을 받은 독립적인 관현악 작품입니다.
이 장르는 훗날 교향시로 발전하는 중요한 전조가 됩니다.
---
5. 피아노의 변신과 피아니즘의 탄생
초기 낭만주의 시기에 피아노는 기술적으로 급격히 발전했습니다.
18세기 말의 피아노는 가볍고 울림이 제한적이었습니다.
그러나 19세기 초를 거치며 철제 프레임이 도입되고 건반 수가 늘어났으며 페달 기능도 크게 발전했습니다.
이 변화로 더 넓은 음역과 긴 음의 지속, 강력한 포르티시모와 섬세한 피아니시모가 가능해졌습니다.
피아노는 19세기 전반 낭만주의 음악의 핵심 악기로 자리 잡았습니다.
---
6. 중기 낭만주의의 핵심 대립 — 표제 음악 대 절대 음악
중기 낭만주의의 역사를 이해하는 가장 중요한 열쇠는 당시 음악계를 양분한 거대한 이념 논쟁입니다.
표제 음악 진영은 음악이 문학, 회화, 드라마, 자연, 철학적 관념과 결합해야 한다고 주장했습니다.
리스트와 바그너가 이 진영의 선봉이었습니다.
반면 절대 음악 진영은 음악은 음악 자체로 완결된 예술이라고 주장했습니다.
브람스가 이 입장의 대표 인물이었습니다.
이 두 진영의 대립은 단순한 취향 차이가 아니었습니다.
음악이 무엇인가, 음악은 어디로 가야 하는가라는 근본적 질문에 대한 논쟁이었습니다.
---
7. 악극 — 오페라의 혁명
바그너는 총체 예술 작품이라는 개념을 제시했습니다.
시와 드라마, 음악, 시각 예술이 완전히 통합된 하나의 예술이 되어야 한다고 주장했습니다.
아리아와 레치타티보의 구분을 없앴습니다.
특정 인물이나 사물, 관념을 대표하는 짧은 음악 동기인 라이트모티프도 사용했습니다.
바그너의 작품은 규모 면에서도 전례가 없었습니다.
「니벨룽의 반지」는 4부작으로 전체 공연 시간이 약 16시간에 달합니다.
1865년에 초연된 「트리스탄과 이졸데」는 화성 언어의 혁명을 보여주는 작품입니다.
특히 '트리스탄 화음'은 전통적인 화성 체계의 한계를 넘어선 것으로 평가받습니다.
---
8. 민족주의 음악의 부상
1848년 혁명 이후 유럽 전역에서 민족 정체성에 대한 관심이 높아졌습니다.
러시아에서는 강력한 5인조가 등장했습니다.
이들은 서유럽 음악을 모방하지 않고 러시아만의 음악을 만들고자 했습니다.
무소륵스키, 보로딘, 림스키코르사코프가 대표 인물입니다.
보헤미아에서는 스메타나가 「나의 조국」을 통해 체코의 자연과 역사를 음악으로 표현했습니다.
노르웨이에서는 그리그가 민속 음악을 바탕으로 독자적인 음악 세계를 구축했습니다.
---
9. 후기 낭만주의 — 독일·오스트리아 교향곡의 대확장
후기 낭만주의에서 독일·오스트리아 음악의 핵심은 교향곡이 전례 없는 규모와 야망으로 팽창하는 것입니다.
브루크너의 교향곡은 바그너의 화성 언어를 흡수하면서도 가톨릭 신앙에서 오는 보편적이고 종교적인 감정을 담으려 했습니다.
말러는 교향곡 안에 성악과 합창을 도입하고, 삶과 죽음·우주와 자연·인간의 고통이라는 주제를 담았습니다.
교향곡 8번은 오케스트라와 합창단을 합쳐 1000명이 넘는 연주자가 필요하다 해서 천인 교향곡이라 불립니다.
리하르트 슈트라우스는 리스트의 교향시 전통을 이어받아 훨씬 더 정교하고 심리적으로 세밀한 교향시를 만들었습니다.
---
10. 프랑스 인상주의 음악의 탄생
독일·오스트리아의 거대하고 무거운 음악에 대한 반발로, 프랑스에서는 음악 인상주의라는 완전히 새로운 방향이 나타납니다.
빛이나 바람, 물의 반짝임처럼 끊임없이 변화하는 자연의 순간적 인상을 음의 색채로 포착하려 했습니다.
음악적으로 인상주의는 기존 조성 화성과 다른 음계를 도입하고, 화성의 기능적 진행보다 색채적 울림 자체를 추구했습니다.
드뷔시의 목신의 오후에의 전주곡은 1894년 초연 당시 기존 음악과 완전히 다른 새로운 음향 세계를 열었다는 평가를 받았습니다.
이 작품이 서양 음악사에서 20세기 음악의 실질적 출발점으로 종종 거론되는 이유입니다.
---
11. 이탈리아 — 베리즈모 오페라
이탈리아에서는 1890년을 기점으로 베리즈모, 즉 사실주의 오페라가 등장합니다.
베리즈모는 낭만주의의 이상화된 감정이 아니라 날 것의 인간적 충동과 폭력을 묘사하는 것을 목표로 했습니다.
푸치니는 베리즈모의 사실성과 낭만주의 선율의 아름다움을 결합해 가장 대중적인 성공을 거뒀습니다.
---
전체 흐름 요약
고전주의에서 낭만주의로의 이행은 베토벤 후기 작품에서 이미 시작되었습니다.
1820년대 독일 기악과 가곡의 발전, 낭만주의 오페라의 탄생을 통해 본격화되었습니다.
연가곡과 피아노 소품, 연주회용 서곡 같은 새로운 장르들이 등장했습니다.
중기에는 표제 음악 대 절대 음악의 이념 논쟁이 음악계를 양분했습니다.
민족주의 음악이 러시아와 보헤미아, 북유럽 등지에서 크게 성장했습니다.
조성 체계는 바그너 이후의 극단적 반음계주의를 거쳐 마침내 해체 직전에 이르고, 1914년 제1차 세계대전은 19세기 유럽 문명과 함께 낭만주의에도 최후의 마침표를 찍었습니다.`;

export const MODERN_CONTENT = `1. 출발점 — 낭만주의 이후 무엇이 남았나?
1900년대 초 서양 음악은 깊은 딜레마 앞에 서 있었습니다.
1000년 이상 서양 음악의 뼈대였던 조성 체계가 바그너 이후의 극단적 반음계주의로 인해 사실상 기능을 잃어가고 있었습니다.
이 막힌 상황에서 20세기 전반 음악은 여러 방향으로 동시에 폭발합니다.
하나의 새로운 주류가 나타난 것이 아니라, 서로 다른 해답을 제시하는 여러 사조가 거의 동시에 등장했습니다.
이것이 20세기 음악의 가장 큰 특징이자, 이전 시대와의 근본적 차이입니다.
---
2. 시대 배경 — 두 차례 세계대전과 음악
20세기 전반은 제1차 세계대전(1914~1918)과 제2차 세계대전(1939~1945) 사이에 끼어 있습니다.
전쟁 자체가 19세기 유럽 문명과 그 문명이 만들어낸 낭만주의적 이상주의에 대한 최후의 심판이었습니다.
나치 독일은 무조 음악과 재즈, 유대계 음악을 퇴폐 예술로 규정하고 금지했습니다.
소련은 스탈린 치하에서 대중이 이해할 수 없는 전위 음악을 형식주의로 비판하고, 음악은 사회주의 내용을 민족적 형식으로 담아야 한다는 사회주의 리얼리즘을 강제했습니다.
이 두 정치 체제의 압박은 수많은 작곡가들을 미국으로 망명하게 만들었고, 이것이 전후 미국이 서양 음악의 새로운 중심지가 되는 계기가 됩니다.
---
3. 표현주의와 무조 음악 — 제2 빈악파
낭만주의의 극단적 주관성이 한계까지 밀려나 내부에서 폭발한 것이 표현주의 음악입니다.
쇤베르크는 1908년경부터 조성의 중심음이 완전히 사라진 무조 음악을 시작합니다.
1909년 작곡된 세 개의 피아노 소품이 역사상 최초의 무조 기악 작품으로 기록됩니다.
이후 쇤베르크는 1920년대 초 12음 기법이라는 새로운 체계를 완성합니다.
12음 기법은 한 옥타브 안의 12개 음을 일정한 순서로 배열해 음렬을 만들고, 이 음렬과 그 역행·역전·역행역전의 48가지 형태를 바탕으로 음악을 구성하는 방식입니다.
제자 알반 베르크와 안톤 베베른이 이 방식을 각자의 방식으로 발전시켰습니다.
이 세 사람을 제2 빈악파라 부릅니다.
베르크는 12음 기법을 사용하면서도 낭만주의적 감정 표현을 유지했고, 베베른은 반대로 극도의 간결함과 응축을 추구했습니다.
---
4. 봄의 제전 — 리듬의 혁명
1913년 5월 29일 파리 샹젤리제 극장에서 스트라빈스키의 발레 음악 봄의 제전이 초연되었습니다.
관객이 무대 위 무용수들과 음악에 야유와 고함을 퍼붓다 결국 몸싸움으로 번진 이 초연은 음악사에서 가장 유명한 소동으로 기록됩니다.
서양 음악은 바로크 이후 2박자 또는 3박자의 규칙적인 리듬 구조를 기반으로 했습니다.
봄의 제전은 이 원칙을 거부합니다.
불규칙하게 변하는 박자표, 강박의 위치를 예측할 수 없게 만드는 리듬 패턴, 타악기의 원시적 타격이 전면에 나서는 방식은 청중이 경험해본 적 없는 음악이었습니다.
봄의 제전이 음악사에서 갖는 의미는 단순히 과격한 작품 하나의 등장이 아닙니다.
리듬이 화성이나 선율과 동등한, 또는 그 이상의 음악적 요소가 될 수 있음을 처음으로 선언한 사건입니다.
---
5. 신고전주의 — 과거와의 대화
제1차 세계대전 이후 1920년대에 나타난 신고전주의는 후기 낭만주의와 표현주의 양쪽 모두에 대한 반발로 등장합니다.
바로크와 고전주의의 명료함과 형식 논리로 돌아가자는 움직임이었습니다.
중요한 것은 신고전주의가 단순히 과거 음악의 복사가 아니었다는 점입니다.
18세기 형식과 구조를 20세기의 화성 언어와 결합하는 방식이었습니다.
봄의 제전으로 전위의 극단을 보여준 스트라빈스키가 1920년대 이후 신고전주의의 선봉이 되었다는 사실이 상징적입니다.
---
6. 민속 음악의 과학적 발굴 — 바르토크
헝가리의 바르토크와 코다이는 1905년경부터 헝가리·루마니아·슬로바키아·불가리아·터키의 농촌을 돌며 수천 곡의 민요를 직접 채보했습니다.
이 과정에서 이들이 발견한 것은 유럽 농촌 음악이 장조·단조 이외의 다양한 음계와 박자 체계를 가지고 있다는 사실이었습니다.
바르토크는 이 민속 음악 재료를 자신의 창작에 직접 통합했습니다.
단순히 선율을 인용하는 것이 아니라, 민요의 음계와 리듬 원리 자체를 작곡의 언어로 흡수했습니다.
---
7. 전후의 출발점 — 새로운 음악을 위한 백지
1945년 제2차 세계대전의 종전은 유럽 문명의 폐허 위에 새로운 출발을 강제했습니다.
낭만주의의 거대 이상주의가 파시즘과 전쟁으로 귀결된 것을 목격한 작곡가들에게, 19세기의 표현 언어로 돌아가는 것은 불가능해 보였습니다.
1946년부터 독일 다름슈타트에서 매해 개최된 국제 현대음악 하기강좌는 전후 전위 음악의 진원지가 됩니다.
루이지 노노·피에르 불레즈·카를하인츠 슈톡하우젠·루치아노 베리오가 이 강좌를 중심으로 활동한 대표적 인물들입니다.
---
8. 총렬주의 — 모든 것을 음렬로
쇤베르크의 12음 기법은 12개의 음높이를 음렬로 조직했습니다.
전후 작곡가들은 여기서 한 걸음 더 나아가, 음높이뿐 아니라 음의 길이·강약·음색·연주법까지 모든 요소를 수학적 음렬로 조직하는 총렬주의를 만들어냈습니다.
불레즈와 슈톡하우젠이 1950년대에 이를 발전시켜 완전한 총렬주의를 실현했습니다.
총렬주의는 음악 언어를 가장 논리적이고 체계적으로 조직할 수 있다는 의미에서 매력적이었지만, 동시에 청중이 음악 안에서 어떠한 패턴이나 방향감도 인식하기 어려워지는 문제를 안고 있었습니다.
---
9. 구체 음악과 전자 음악
1948년 파리 방송국 기사 피에르 셰페르는 철도 소음, 동물 소리, 자연의 소리 등 실제 세계의 모든 소리를 녹음해 이를 기계적으로 변형·조합·겹쳐서 음악을 만드는 구체 음악을 시작했습니다.
1951년 독일 쾰른 방송국에 세계 최초의 전자 음악 스튜디오가 설립되었고, 슈톡하우젠이 이곳을 중심으로 전자 음악의 가능성을 탐구했습니다.
전자 음악의 의미는 악기와 연주자에 의존하지 않아도 된다는 점에 있었습니다.
이론적으로 어떤 음색도, 어떤 미세한 음높이 차이도, 어떤 복잡한 리듬도 전자 장치로 실현할 수 있었습니다.
---
10. 우연성 음악 — 케이지와 미니멀리즘
미국의 존 케이지는 동양 철학, 특히 선불교와 역경의 영향을 받아 음악에서 작곡가의 의도와 자아를 지우려 했습니다.
그의 작품 4분 33초(1952)는 어떤 악기든 연주자가 앞에 앉아 악보를 펼치지만 한 음도 연주하지 않고 4분 33초를 그냥 보내는 것입니다.
이것은 침묵이란 없다는 것, 연주자가 소리를 내지 않는 동안 청중의 기침 소리, 바람 소리, 옷 스치는 소리 등 공연장의 모든 환경 소리가 음악이 된다는 주장이었습니다.
1960년대 미국에서 미니멀리즘이 등장합니다.
총렬주의가 모든 요소를 극도로 복잡하게 조직했다면, 미니멀리즘은 극도로 단순한 음형과 화성을 오랫동안 반복하는 방식을 선택했습니다.
스티브 라이히, 필립 글래스, 테리 라일리가 대표 인물입니다.
미니멀리즘은 처음에는 지나치게 단순하다는 비판을 받았지만, 오히려 일반 청중에게 가장 널리 받아들여진 현대 음악 사조 중 하나가 되었습니다.
---
11. 포스트모더니즘과 현대 음악의 다원화
1980년대 음악에 가장 큰 영향을 미친 사상은 포스트모더니즘입니다.
포스트모더니즘은 어떤 하나의 양식이나 방법이 다른 것보다 본질적으로 우월하다는 생각을 거부합니다.
1970년대 이후 현대 음악은 더 이상 하나의 중심 사조로 설명할 수 없게 됩니다.
각 작곡가가 자신만의 언어를 구축하는 다원주의 시대가 시작됩니다.
에스토니아의 아르보 패르트는 팅티나불리라고 불리는 독자적인 작법을 개발했습니다.
복잡성과 경쟁을 버리고 극도의 단순함에서 깊이를 찾는 이 음악은 1980년대부터 폭발적인 청중 반응을 얻었습니다.
1980년대부터 디지털 기술이 음악에 급격히 침투했습니다.
개인 컴퓨터의 보급과 MIDI 표준의 확립으로, 이제 스튜디오와 오케스트라 없이도 개인이 음악을 만들 수 있게 되었습니다.
---
전체 흐름 요약
20세기 전반 음악은 낭만주의 이후의 조성 해체에 여러 방향으로 동시에 응답했습니다.
쇤베르크가 무조 음악과 12음 기법으로 조성의 대안 체계를 만들고, 스트라빈스키의 봄의 제전이 리듬으로 음악의 새로운 중심을 제시했습니다.
신고전주의는 과거와의 대화로 명료함을 되찾으려 했고, 바르토크는 민속 음악 속에서 새로운 음악 언어를 발굴했습니다.
전후에는 총렬주의, 구체 음악, 전자 음악, 우연성 음악 등 더욱 급진적인 실험들이 폭발했습니다.
1980년대 이후 다원주의가 시작되면서 오늘날 현대 음악은 서로 다른 언어들이 공존하는 거대한 네트워크가 되었습니다.`;
